<template>
	<transition name="modal">
       <div class="modal-mask deleteModal">
         <div class="modal-wrapper">
            <div class="modal-container">
				<div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLongTitle">{{header || 'Success'}}</h5>
                    <button type="button" class="close" @click="closeModal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <p>{{message || 'Campaign has been saved successfully!'}}</p>
                </div>

				<div class="modal-footer" style = "flex: 0 0 auto;display: flex;justify-content: center;">
					<div class="mt-2" style="text-align: center">
						<button
							type="button"
							class="btn btn-primary"
							data-dismiss="modal"
							@click = "closeModal"
							>Close
						</button>
					</div>
				</div>

                <!-- <div class="modal-footer">
                    <button type="button" @click="closeModal" class="btn btn-secondary" data-dismiss="modal">Close</button>
                </div> -->
            </div>
        </div>
    </div>
  </transition>
</template>

<script>
export default {
    name:'AddCampaignConfirmModal',
    data() {
        return {

        }
    },
    props: {
		message:{
			type:String,
			required:false
		},
		header:{
			type:String,
			required:false
		}
					},
	mounted(){

	},
    methods: {
        closeModal() {
			this.$emit('closeModal')
        }
    },
	mounted(){
	 //
	},
}
</script>

<style lang="scss">
	.deleteModal {
		.mso-popover-style{
			/* display : flex;
			justify-content: center;
			align-items: center; */
		}
	}
	/* .popover.fade.show.bs-popover-left {
	   max-width : 310px !important
	} */

	.deleteModal {
		.modal-mask {
			position: fixed;
			z-index: 9998;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			background-color: rgba(0, 0, 0, .5);
			display: table;
			transition: opacity .3s ease;
		}
	}

	.deleteModal {
		.modal-wrapper {
	  		display: table-cell;
			  vertical-align: middle;
		}
	}

	.deleteModal {
		.modal-container {
			width: 100%;
			max-width : 800px;
			margin: 0px auto;
			padding-top:0px;
			background-color: #fff;
			border-radius: .3rem;
			box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
			transition: all .3s ease;
			font-family: Helvetica, Arial, sans-serif;
		}
	}

	.deleteModal {
		.modal-enter {
			  opacity: 0;
		}
	}

	.deleteModal {
		.modal-leave-active {
			  opacity: 0;
		}
	}
	.deleteModal .modal-enter .modal-container,
	.deleteModal .modal-leave-active .modal-container {
	  -webkit-transform: scale(1.1);
	  transform: scale(1.1);
	}

	.deleteModal {
		.modal-title{
			text-align: center;
		}
	}
</style>
